import DynamicHelmet from "../components/DynamicHelmet";
import GalleryPage from "../pages/GalleryPage";

const Gallery = () => {
  return <>
    <DynamicHelmet page="galleria" />
    <GalleryPage />
  </>
  ;
};

export default Gallery;
